// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"drop-zone_wrapper__1EXod","banner_text":"drop-zone_banner_text__3M1-i","banner":"drop-zone_banner__2OFxq","input":"drop-zone_input__1-f60"};